import React, { useEffect } from 'react';
import '../CSS/Gallery.css';

const GALLERY_IMAGES = [
  { src: require('../assets/award_receiving.jpg'),  alt: 'NGT Award Ceremony' },
  { src: require('../assets/award_receiving1.jpg'), alt: 'NGT Award Receiving' },
  { src: require('../assets/award2.jpg'),           alt: 'NGT Recognition Award' },
  { src: require('../assets/award3.jpg'),           alt: 'NGT Academic Achievement' },
  { src: require('../assets/award4.jpg'),           alt: 'NGT Excellence Award' },
  { src: require('../assets/Nalanda.bmp'),          alt: 'Nalanda Group Tuitions' },
];

const Gallery = () => {
  useEffect(() => { window.scrollTo(0, 0); }, []);
  return (
    <>
      <div className="ngt-page-banner">
        <h1>Gallery</h1>
        <p>Milestones, achievements, and memories from Nalanda Group Tuitions</p>
      </div>
      <nav aria-label="breadcrumb" className="container mt-3">
        <ol className="breadcrumb" style={{ fontSize: '0.85rem' }}>
          <li className="breadcrumb-item"><a href="/">Home</a></li>
          <li className="breadcrumb-item active">Gallery</li>
        </ol>
      </nav>
      <section className="ngt-gallery-grid">
        <div className="container">
          <h2 className="section-title">Our Moments</h2>
          <p className="section-subtitle">Awards, events, and achievements that define our journey</p>
          <div className="row g-3">
            {GALLERY_IMAGES.map((img, i) => (
              <div key={i} className="col-6 col-md-4 col-lg-3">
                <div className="gallery-img">
                  <img src={img.src} alt={img.alt} loading="lazy" />
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>
    </>
  );
};

export default Gallery;
